//This file is used to configure cometd and define its related functions for subscribing and publishing
//Imports section
import cometdLib from "cometd";
// import HWUser from "../Simplify360Chat/HWLibrary/HWUser";
// import uuid from "react-uuid";
import { s360ConfigService } from "../Simplify360Chat/Services/S360Config";
// import { isNullOrUndefined } from "../Simplify360Chat/HWLibrary/HWUtils";
// import { s360ConfigService } from "../Simplify360Chat/Services/S360Config";

let cometd;
let isConnected = false;
let recieveURLGlobal;
let subscription;
let listOfComponentsToUpdate;
let refElementGlobal;
export const CometdDService = (refElement, listenChannel, appComponent) => {
  // var network = navigator.onLine ? "online" : "offline";
  //Variable declaration
  refElementGlobal = refElement;
  cometd = new cometdLib.CometD();
  listOfComponentsToUpdate = ["ConversationPage", "LandingPage"];
  const host = s360ConfigService.config.host;
  console.log("ENVIRONMANET", host);
  //   let listOfComponentsToUpdate = ["ConversationPage","LandingPage"];
  let connectionURL = `https://${host}/bmcometd/cometd`;
  // let connectionURL = "https://devdata.simplify360.com/bmcometd/cometd";
  // let sendURl = "/cometd-server-channel";
  let recieveURL = `/${listenChannel}`;
  console.log(recieveURL,"RECIEVE URL");
  recieveURLGlobal = recieveURL;
  let secureCometdToken = localStorage.getItem("cometdToken");
  let secureCometdUser = localStorage.getItem("cometdUser");
  console.log(secureCometdToken,secureCometdUser,"batmannn")
  let additional = {
    ext: {

      "com.inrev.authn": {
        user: !!secureCometdUser && secureCometdUser !== 'undefined' ? secureCometdUser : "cometuser1",
        token: !!secureCometdToken && secureCometdToken !== 'undefined' ? secureCometdToken : "adfwew283292"
      }
    },
  };

  //cometd configuration
  cometd.websocketEnabled = true;
  console.log("COMETD-LOG:CONFIGURING COMETD", connectionURL);
  cometd.configure({
    url: connectionURL.trim(),
  });

  //cometd handshake
  cometd.handshake(additional, function (handshakeReply) {
    if (handshakeReply.successful) {
      console.log(
        "COMETD-LOG:HANDSHAKE SUCCESSFULL",
        refElement,
        connectionURL
      );
      subscription = cometd.batch(function () {
        cometd.subscribe(
          recieveURL,
          function (message) {
            if (message) {
              console.log("COMETD-LOG: EVENT TRIGGERED", message);
              let customEvent = new CustomEvent("updateComponent", {
                detail: {
                  componentsToUpdate: listOfComponentsToUpdate,
                  data: {
                    message,
                    /* data to be used from events received can be used for manipulating the component or any required funtion */
                  },
                },
                bubbles: true,
              }); /* Dispatch the CustomEvent to the ref element from where it will be triggered */
    
              console.log("subscribed from cometd");
              refElement.current.dispatchEvent(customEvent);
              console.log("COMETD-LOG-CHECK: 1 service");
            }
          },
          function (ack) {
            if (ack.successful) {
              console.log("COMETD-LOG: RECIEVE CHANNEL SUBSCRIBED", refElement);
              // alert("subscibed...")
              // localStorage.setItem("subscribed", true);
            }
          }
        );
      })
      isConnected = true;
    } else {
      console.log("failed in service", appComponent);
      appComponent.actions.handleShowReloadPopup();
    }
  });

  //cometd subscribe

  // alert("subscibing...")
   
  // subscription = cometd.batch(function () {
  //   cometd.subscribe(
  //     recieveURL,
  //     function (message) {
  //       if (message) {
  //         console.log("COMETD-LOG: EVENT TRIGGERED", message);
  //         let customEvent = new CustomEvent("updateComponent", {
  //           detail: {
  //             componentsToUpdate: listOfComponentsToUpdate,
  //             data: {
  //               message,
  //               /* data to be used from events received can be used for manipulating the component or any required funtion */
  //             },
  //           },
  //           bubbles: true,
  //         }); /* Dispatch the CustomEvent to the ref element from where it will be triggered */

  //         console.log("subscribed from cometd");
  //         refElement.current.dispatchEvent(customEvent);
  //         console.log("COMETD-LOG-CHECK: 1 service");
  //       }
  //     },
  //     function (ack) {
  //       if (ack.successful) {
  //         console.log("COMETD-LOG: RECIEVE CHANNEL SUBSCRIBED", refElement);
  //         // alert("subscibed...")
  //         // localStorage.setItem("subscribed", true);
  //       }
  //     }
  //   );
  // })

}
// localStorage.setItem("subscription", JSON.stringify(subscription));


//   const fetchConversations = (limit, lastFetchedSession) => {
//     console.log("COMETD-LOG: IN FETCH CONVERSATIONS")
//     const customerId = HWUser.customerId();
//     const clientUser = HWUser.xmppUserName();
//     const params = {
//       configId: s360ConfigService.config.configId,
//       command: "GET_SESSIONS_REQUEST",
//       customerId,
//       convoType: "TEXT",
//       clientUser,
//       fromUi: false,
//       assignedTo: -1,
//       isJabber: false,
//       fromApi: false,
//       firstMessageTimestamp: 0,
//       uuid
//     };
//     params["limit"] = limit || 30;
//     params["sourceType"] = HWUser.sourceType() || 60;
//     if (lastFetchedSession) {
//       params["sessionInfo"] = lastFetchedSession;
//     }

//       cometd.publish(sendURl,JSON.stringify(params),function ack(message){
// if(message){
//     return message;
// }
//     });
//   };
//  return {fetchConversationsCMD:fetchConversations}
//   cometd.addListener('/meta/disconnect', function(message)
// {
//   cometd.handshake(additional, function (handshakeReply) {
//     if (handshakeReply.successful) {
//       console.log("COMETD-LOG:HANDSHAKE SUCCESSFULL", refElement);
//     } else console.error("COMETD-LOG:HANDHSAKE FAILED");
//   });

// });

// window.setInterval(() => {
//   cometd.unsubscribe(subscription);

//   //  console.log("unsubscribed from cometd")
//   //  console.log("re-subscribed from cometd")
//   subscription = cometd.subscribe(
//     recieveURL,
//     function (message) {
//       if (message) {
//         let customEvent = new CustomEvent("updateComponent", {
//           detail: {
//             componentsToUpdate: listOfComponentsToUpdate,
//             data: {
//               message,
//               /* data to be used from events received can be used for manipulating the component or any required funtion */
//             },
//           },
//           bubbles: true,
//         }); /* Dispatch the CustomEvent to the ref element from where it will be triggered */
//         // console.log("COMETD-LOG: EVENT TRIGGERED IN TIMEOUT", message);
//         console.log("RE-SUBSCRIBING TO CLIENT CHANNEL AGAIN", recieveURL);
//         refElement.current.dispatchEvent(customEvent);
//         // console.log("COMETD-LOG-CHECK: 1 service");
//       }
//     },
//     function (ack) {
//       if (ack.successful) {
//         console.log("COMETD-LOG: RECIEVE CHANNEL SUBSCRIBED", refElement);
//         // alert("subscibed...")
//         localStorage.setItem("subscribed", true);
//       }
//     }
//   );
// }, 1000 * 1);




const onConnectionLost = () => {
  console.log("Connection Lost");
  isConnected = false;

}
export const addConnectionLostListener = () => {
  console.log("CONNECTION LOST RETRYING..");
  cometd.addListener('/meta/connect', onConnectionLost);
};

export const removeConnectionLostListener = () => {
console.log("CONNECTION ESTABLISHED")
  cometd.removeListener('/meta/connect', onConnectionLost);
};

export const reConnectCometd = () => {

  console.log("TRYING TO RECONNECT ")
  subscription && cometd.unsubscribe(subscription);

  //  console.log("unsubscribed from cometd")
  //  console.log("re-subscribed from cometd")
  subscription = cometd.subscribe(
    recieveURLGlobal,
    function (message) {
      if (message) {
        let customEvent = new CustomEvent("updateComponent", {
          detail: {
            componentsToUpdate: listOfComponentsToUpdate,
            data: {
              message,
              /* data to be used from events received can be used for manipulating the component or any required funtion */
            },
          },
          bubbles: true,
        }); /* Dispatch the CustomEvent to the ref element from where it will be triggered */
        // console.log("COMETD-LOG: EVENT TRIGGERED IN TIMEOUT", message);
        console.log("RE-SUBSCRIBING TO CLIENT CHANNEL AGAIN", recieveURLGlobal);
        refElementGlobal.current.dispatchEvent(customEvent);
        // console.log("COMETD-LOG-CHECK: 1 service");
      }
    },
    function (ack) {
      if (ack.successful) {
        console.log("COMETD-LOG: RECIEVE CHANNEL SUBSCRIBED", refElementGlobal);
        // alert("subscibed...")
        // localStorage.setItem("subscribed", true);
      }
    }
  );
}